import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface FullScreenToggleIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
  isFullscreen: boolean;
}

const FullScreenToggleIcon: React.FC<FullScreenToggleIconProps> = (props) => {
  const { isFullscreen, strokeWidth = 2, ...svgProps } = props;
  return !isFullscreen ? (
    <SvgIcon {...svgProps} viewBox="0 0 24 24" className='sx-icon-fullscreenfalse'>
      <polyline points="9 3 3 3 3 9" fill="none" stroke={props.color || 'currentColor'} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="15 3 21 3 21 9" fill="none" stroke={props.color || 'currentColor'} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="9 21 3 21 3 15" fill="none" stroke={props.color || 'currentColor'} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="15 21 21 21 21 15" fill="none" stroke={props.color || 'currentColor'} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  ) : (
    <SvgIcon {...svgProps} viewBox="0 0 24 24" className='sx-icon-fullscreentrue'>
      <polyline points="3 9 9 9 9 3" fill="none" stroke={props.color || 'currentColor'} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="21 9 15 9 15 3" fill="none" stroke={props.color || 'currentColor'} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="3 15 9 15 9 21" fill="none" stroke={props.color || 'currentColor'} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="21 15 15 15 15 21" fill="none" stroke={props.color || 'currentColor'} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export default FullScreenToggleIcon;
